define("ROOM4.CCAProductGallery.CCAProductGallery.SchemaHelper", [
  "jQuery",
  "Configuration",
], function (jQuery, Configuration) {
  "use strict";

  var COMPANY_NAME = "Canada Custom Autoworks";
  var COMPANY_URL = "https://www.canadacustomautoworks.com/";
  var COMPANY_LOGO_URL =
    "https://www.canadacustomautoworks.com/site/Home%20Assets/Site_logo.png";
  var IMAGE_LICENSE_URL =
    "https://www.canadacustomautoworks.com/terms-of-service#images";
  var IMAGE_ACQUIRE_LICENSE_URL =
    "https://www.canadacustomautoworks.com/contact";
  var IN_STOCK_URL = "https://schema.org/InStock";
  var NEW_CONDITION_URL = "https://schema.org/NewCondition";
  var PRICE_CURRENCY = "CAD";

  function trimValue(value) {
    return value === null || value === undefined ? "" : String(value).trim();
  }

  function getPublicationYear(value) {
    var match = trimValue(value).match(/\b\d{4}\b/);

    return match ? match[0] : "";
  }

  function getImageCopyrightNotice(publicationDate) {
    var publicationYear = getPublicationYear(publicationDate);

    return publicationYear
      ? "(c) " +
          publicationYear +
          " " +
          COMPANY_NAME +
          ". All rights reserved."
      : "";
  }

  function getOrganizationId(url) {
    return String(url || getAbsoluteUrl("/"))
      .replace(/#.*$/, "")
      .replace(/\/+$/, "") + "/#organization";
  }

  function getOrganizationSameAs() {
    var configuredProfiles = Configuration.get(
      "CCAProductGallery.organization.sameAs"
    ) || [];
    var profileUrls = [];

    configuredProfiles.forEach(function (profile) {
      var profileUrl = trimValue(
        typeof profile === "string"
          ? profile
          : profile && (profile.profileUrl || profile.url)
      );

      if (
        profileUrl &&
        profileUrl.toLowerCase() !== "undefined" &&
        profileUrl.toLowerCase() !== "null"
      ) {
        profileUrls.push(getAbsoluteUrl(profileUrl));
      }
    });

    return profileUrls;
  }

  function getOrganizationSchemaContext() {
    var name = trimValue(
      Configuration.get("CCAProductGallery.organization.name")
    );
    var url = trimValue(
      Configuration.get("CCAProductGallery.organization.url")
    );
    var logoUrl = trimValue(
      Configuration.get("CCAProductGallery.organization.logoUrl")
    );
    var telephone = trimValue(
      Configuration.get("CCAProductGallery.organization.telephone")
    );
    var email = trimValue(
      Configuration.get("CCAProductGallery.organization.email")
    );
    var sameAs = getOrganizationSameAs();

    url = url ? getAbsoluteUrl(url) : "";
    logoUrl = logoUrl ? getAbsoluteUrl(logoUrl) : "";

    return {
      id: getOrganizationId(url),
      name: name,
      url: url,
      logoUrl: logoUrl,
      telephone: telephone,
      email: email,
      sameAs: sameAs,
      hasUrl: !!url,
      hasLogo: !!logoUrl,
      hasTelephone: !!telephone,
      hasEmail: !!email,
      hasSameAs: !!sameAs.length,
    };
  }

  /**
   * @typedef {Object} GalleryComponent
   * @property {string|number} [itemid]
   * @property {string} [itemnumber]
   * @property {string} [displayname]
   * @property {string} [itemname]
   * @property {string} [brand]
   * @property {string} [model]
   * @property {Object} [specs]
   * @property {string} [classfullname]
   * @property {string} [urlcomponent]
   * @property {string} [imageurl]
   * @property {string} [storedescription]
   * @property {string|number|null} [onlineprice]
   */

  /**
   * @typedef {Object} GalleryImage
   * @property {string} [url]
   * @property {string} [alt]
   * @property {string} [caption]
   */

  /**
   * @typedef {Object} ModelLike
   * @property {function(string): *} get
   */

  /**
   * @typedef {Object} ProductSchemaContext
   * @property {string} domId
   * @property {string} id
   * @property {string} name
   * @property {string} category
   * @property {string} sku
   * @property {string} brand
   * @property {string} model
   * @property {Array.<{name:string,value:(string|number)}>} additionalProperties
   * @property {string} url
   * @property {string} image
   * @property {string} description
   * @property {string} itemCondition
   * @property {string} availability
   * @property {string} priceCurrency
   * @property {number|null} price
   * @property {boolean} hasSku
   * @property {boolean} hasBrand
   * @property {boolean} hasModel
   * @property {boolean} hasAdditionalProperties
   * @property {boolean} hasUrl
   * @property {boolean} hasImage
   * @property {boolean} hasDescription
   * @property {boolean} hasPrice
   */

  /**
   * @typedef {Object} ImageSchemaContext
   * @property {string} domId
   * @property {string} id
   * @property {string} url
   * @property {string} contentUrl
   * @property {string} name
   * @property {string} caption
   * @property {string} license
   * @property {string} acquireLicensePage
   * @property {string} creditText
   * @property {string} copyrightNotice
   * @property {string} creatorName
   * @property {boolean} hasCaption
   * @property {boolean} hasCopyrightNotice
   */

  /**
   * @typedef {Object} ImageSchemaOptions
   * @property {string} [contentUrl]
   * @property {boolean} [useIdForUrl]
   * @property {*} [publicationDate]
   */

  /**
   * @typedef {Object} VehicleSchemaContext
   * @property {string} id
   * @property {string} name
   * @property {string} brand
   * @property {string} productionDate
   * @property {string} model
   * @property {string} imageId
   * @property {boolean} hasBrand
   * @property {boolean} hasProductionDate
   * @property {boolean} hasModel
   * @property {boolean} hasImage
   */

  /**
   * @typedef {Object.<string, *>} JsonLdObject
   */

  /**
   * @param {string} pathOrUrl
   * @returns {string}
   */
  function getAbsoluteUrl(pathOrUrl) {
    var value = String(pathOrUrl || "").trim();
    var location;
    var absoluteUrl;

    if (!value) {
      return "";
    }

    if (/^https?:\/\//i.test(value)) {
      return encodeURI(value);
    }

    location = window.location;

    if (value.indexOf("//") === 0) {
      return encodeURI(location.protocol + value);
    }

    absoluteUrl =
      location.protocol +
      "//" +
      location.host +
      (value.charAt(0) === "/" ? value : "/" + value);

    return encodeURI(absoluteUrl);
  }

  /**
   * @param {*} value
   * @returns {string}
   */
  function stripHtml(value) {
    return jQuery("<div/>")
      .html(String(value || "").replace(/<[^>]+>/g, " "))
      .text()
      .replace(/\s+/g, " ")
      .trim();
  }

  /**
   * @param {*} value
   * @returns {number|null}
   */
  function toNumber(value) {
    var parsed = parseFloat(value);

    return isNaN(parsed) ? null : parsed;
  }

  /**
   * @param {GalleryComponent} component
   * @param {string} [fallbackTitle]
   * @returns {string}
   */
  function getComponentTitle(component, fallbackTitle) {
    return (
      component.displayname ||
      component.itemname ||
      component.itemnumber ||
      fallbackTitle ||
      ""
    );
  }

  /**
   * @param {*} value
   * @returns {string}
   */
  function capitalize(value) {
    var normalizedValue = String(value || "").trim().toLowerCase();

    return normalizedValue
      ? normalizedValue.charAt(0).toUpperCase() + normalizedValue.slice(1)
      : "";
  }

  /**
   * Returns the parent NetSuite item class, for example "Wheels" from
   * "WHEELS : CAR/SUV WHEEL".
   *
   * @param {GalleryComponent} component
   * @returns {string}
   */
  function getComponentCategory(component) {
    var classFullName = String(component.classfullname || "");
    var parentClass = classFullName.split(" : ")[0];

    return capitalize(parentClass);
  }

  /**
   * @param {*} value
   * @returns {string}
   */
  function getDomIdFragment(value) {
    var fragment = String(value || "")
      .replace(/[^A-Za-z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "");

    return fragment || "item";
  }

  /**
   * @param {string} parentClass
   * @returns {boolean}
   */
  function isWheelOrTire(parentClass) {
    var normalizedParentClass = String(parentClass || "").toLowerCase();

    return (
      normalizedParentClass === "wheels" ||
      normalizedParentClass === "tires"
    );
  }

  /**
   * @param {GalleryComponent} component
   * @returns {boolean}
   */
  function isWheelOrTireComponent(component) {
    return isWheelOrTire(getComponentCategory(component || {}));
  }

  /**
   * @param {GalleryComponent} component
   * @returns {string}
   */
  function getProductUrl(component) {
    var urlComponent = String(component.urlcomponent || "").replace(/^\/+/, "");

    return urlComponent ? getAbsoluteUrl(urlComponent) : "";
  }

  /**
   * @param {GalleryComponent} component
   * @param {number} index
   * @param {string} pageUrl
   * @returns {string}
   */
  function getProductId(component, index, pageUrl) {
    return (
      pageUrl +
      "#product-" +
      encodeURIComponent(String(component.itemid || index + 1))
    );
  }

  /**
   * @param {GalleryComponent} component
   * @param {number} index
   * @returns {string}
   */
  function getProductDomId(component, index) {
    return (
      "ccaproductgallery-schema-product-" +
      getDomIdFragment(component.itemid || index + 1)
    );
  }

  /**
   * @param {*} value
   * @returns {string|number|null}
   */
  function normalizePropertyValue(value) {
    var normalizedValue;

    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === "number") {
      return isNaN(value) ? null : value;
    }

    normalizedValue = trimValue(value);

    return normalizedValue && normalizedValue !== "None"
      ? normalizedValue
      : null;
  }

  /**
   * @param {Array.<{name:string,value:(string|number)}>} properties
   * @param {string} name
   * @param {*} value
   */
  function addAdditionalProperty(properties, name, value) {
    var normalizedValue = normalizePropertyValue(value);

    if (normalizedValue === null) {
      return;
    }

    properties.push({
      name: name,
      value: normalizedValue,
    });
  }

  /**
   * @param {GalleryComponent} component
   * @param {string} category
   * @returns {Array.<{name:string,value:(string|number)}>}
   */
  function getAdditionalProperties(component, category) {
    var specs = component.specs || {};
    var properties = [];
    var tireSize;

    if (category === "Wheels") {
      (specs.wheelBoltPatterns || []).forEach(function (boltPattern) {
        addAdditionalProperty(properties, "Bolt Pattern", boltPattern);
      });
      addAdditionalProperty(properties, "Offset", specs.wheelOffset);
      addAdditionalProperty(properties, "Diameter", specs.wheelDiameter);
      addAdditionalProperty(properties, "Width", specs.wheelWidth);
      addAdditionalProperty(properties, "Hub Bore", specs.wheelHubBore);
      (specs.wheelFinishes || []).forEach(function (finish) {
        addAdditionalProperty(properties, "Finish", finish);
      });
    }

    if (
      category === "Tires" &&
      normalizePropertyValue(specs.tireWidth) !== null &&
      normalizePropertyValue(specs.tireAspectRatio) !== null &&
      normalizePropertyValue(specs.tireRimDiameter) !== null
    ) {
      tireSize =
        trimValue(specs.tireWidth) +
        "/" +
        trimValue(specs.tireAspectRatio) +
        "R" +
        trimValue(specs.tireRimDiameter);
      addAdditionalProperty(properties, "Size", tireSize);
    }

    if (category === "Tires") {
      addAdditionalProperty(properties, "Load Index", specs.tireLoadIndex);
      addAdditionalProperty(properties, "Service Type", specs.tireServiceType);
    }

    return properties;
  }

  /**
   * @param {GalleryComponent} component
   * @param {number} index
   * @param {string} pageUrl
   * @param {string} [fallbackTitle]
   * @returns {ProductSchemaContext|null}
   */
  function getProductSchemaContext(component, index, pageUrl, fallbackTitle) {
    var productUrl = getProductUrl(component);
    var price = toNumber(component.onlineprice);
    var plainDescription = stripHtml(component.storedescription);
    var imageUrl = component.imageurl ? getAbsoluteUrl(component.imageurl) : "";
    var category = getComponentCategory(component);
    var name = getComponentTitle(component, fallbackTitle);
    var additionalProperties;

    if (!isWheelOrTire(category)) {
      return null;
    }

    additionalProperties = getAdditionalProperties(component, category);

    return {
      domId: getProductDomId(component, index),
      id: getProductId(component, index, pageUrl),
      name: name,
      category: category,
      sku: component.itemnumber || "",
      brand: component.brand || "",
      model: component.model || "",
      additionalProperties: additionalProperties,
      url: productUrl,
      image: imageUrl,
      description: plainDescription || name,
      itemCondition: NEW_CONDITION_URL,
      availability: IN_STOCK_URL,
      priceCurrency: PRICE_CURRENCY,
      price: price,
      hasSku: !!component.itemnumber,
      hasBrand: !!component.brand,
      hasModel: !!component.model,
      hasAdditionalProperties: !!additionalProperties.length,
      hasUrl: !!productUrl,
      hasImage: !!imageUrl,
      hasDescription: !!(plainDescription || name),
      hasPrice: price !== null,
    };
  }

  /**
   * @param {GalleryComponent} component
   * @param {number} index
   * @param {string} pageUrl
   * @param {string} [fallbackTitle]
   * @returns {JsonLdObject|null}
   */
  function getProductJsonLd(component, index, pageUrl, fallbackTitle) {
    var productSchema = getProductSchemaContext(
      component,
      index,
      pageUrl,
      fallbackTitle
    );
    var product;

    if (!productSchema) {
      return null;
    }

    product = {
      "@type": "Product",
      "@id": productSchema.id,
      name: productSchema.name,
      category: productSchema.category,
      offers: {
        "@type": "Offer",
        availability: productSchema.availability,
        itemCondition: productSchema.itemCondition,
        priceCurrency: productSchema.priceCurrency,
      },
    };

    if (productSchema.sku) {
      product.sku = productSchema.sku;
    }

    if (productSchema.brand) {
      product.brand = {
        "@type": "Brand",
        name: productSchema.brand,
      };
    }

    if (productSchema.model) {
      product.model = productSchema.model;
    }

    if (productSchema.additionalProperties.length) {
      product.additionalProperty = productSchema.additionalProperties.map(
        function (property) {
          return {
            "@type": "PropertyValue",
            name: property.name,
            value: property.value,
          };
        }
      );
    }

    if (productSchema.url) {
      product.url = productSchema.url;
      product.offers.url = productSchema.url;
    }

    if (productSchema.image) {
      product.image = productSchema.image;
    }

    if (productSchema.description) {
      product.description = productSchema.description;
    }

    if (productSchema.hasPrice) {
      product.offers.price = productSchema.price;
    }

    return product;
  }

  /**
   * @param {GalleryImage} image
   * @param {number} index
   * @param {string} pageUrl
   * @param {string} [fallbackName]
   * @param {ImageSchemaOptions} [options]
   * @returns {ImageSchemaContext|null}
   */
  function getImageSchemaContext(image, index, pageUrl, fallbackName, options) {
    var imageUrl;
    var contentUrl;
    var caption;
    var imageId;
    var copyrightNotice;

    if (!image || !image.url) {
      return null;
    }

    imageUrl = getAbsoluteUrl(image.url);
    contentUrl = getAbsoluteUrl(
      (options && options.contentUrl) || image.url
    );
    caption = image.caption || image.alt || fallbackName || "";
    imageId = pageUrl + "#image-" + (index + 1);
    copyrightNotice = getImageCopyrightNotice(
      options && options.publicationDate
    );

    return {
      domId: "ccaproductgallery-schema-image-" + (index + 1),
      id: imageId,
      url: options && options.useIdForUrl ? imageId : imageUrl,
      contentUrl: contentUrl,
      name: caption,
      caption: caption,
      license: IMAGE_LICENSE_URL,
      acquireLicensePage: IMAGE_ACQUIRE_LICENSE_URL,
      creditText: COMPANY_NAME,
      copyrightNotice: copyrightNotice,
      creatorName: COMPANY_NAME,
      hasCaption: !!caption,
      hasCopyrightNotice: !!copyrightNotice,
    };
  }

  /**
   * @param {GalleryImage} image
   * @param {number} index
   * @param {string} pageUrl
   * @param {string} [fallbackName]
   * @param {ImageSchemaOptions} [options]
   * @returns {JsonLdObject|null}
   */
  function getImageJsonLd(image, index, pageUrl, fallbackName, options) {
    var imageSchema = getImageSchemaContext(
      image,
      index,
      pageUrl,
      fallbackName,
      options
    );

    if (!imageSchema) {
      return null;
    }

    var imageJsonLd = {
      "@type": "ImageObject",
      "@id": imageSchema.id,
      url: imageSchema.url,
      contentUrl: imageSchema.contentUrl,
      name: imageSchema.name,
      caption: imageSchema.caption,
      license: imageSchema.license,
      acquireLicensePage: imageSchema.acquireLicensePage,
      creditText: imageSchema.creditText,
      creator: {
        "@type": "Organization",
        name: imageSchema.creatorName,
      },
    };

    if (imageSchema.hasCopyrightNotice) {
      imageJsonLd.copyrightNotice = imageSchema.copyrightNotice;
    }

    return imageJsonLd;
  }

  /**
   * @param {ModelLike} model
   * @returns {string}
   */
  function getVehicleName(model) {
    var year = model.get("year") || "";
    var make = model.get("make") || "";
    var vehicleModel = model.get("model") || "";
    var vehicleName = model.get("vehicle") || "";

    if (vehicleName) {
      return vehicleName;
    }

    return [year, make, vehicleModel].join(" ").replace(/\s+/g, " ").trim();
  }

  /**
   * @param {ModelLike} model
   * @param {string} pageUrl
   * @param {ImageSchemaContext|JsonLdObject|null} primaryImage
   * @returns {VehicleSchemaContext|null}
   */
  function getVehicleSchemaContext(model, pageUrl, primaryImage) {
    var year = model.get("year") || "";
    var make = model.get("make") || "";
    var vehicleModel = model.get("model") || "";
    var vehicleName = getVehicleName(model);

    if (!vehicleName) {
      return null;
    }

    return {
      id: pageUrl + "#vehicle",
      name: vehicleName,
      brand: make,
      productionDate: year,
      model: vehicleModel,
      imageId:
        primaryImage && (primaryImage.id || primaryImage["@id"])
          ? primaryImage.id || primaryImage["@id"]
          : "",
      hasBrand: !!make,
      hasProductionDate: !!year,
      hasModel: !!vehicleModel,
      hasImage: !!(
        primaryImage && (primaryImage.id || primaryImage["@id"])
      ),
    };
  }

  /**
   * @param {ModelLike} model
   * @param {string} pageUrl
   * @param {ImageSchemaContext|JsonLdObject|null} primaryImage
   * @returns {JsonLdObject|null}
   */
  function getVehicleJsonLd(model, pageUrl, primaryImage) {
    var vehicleSchema = getVehicleSchemaContext(model, pageUrl, primaryImage);
    var vehicleJsonLd;

    if (!vehicleSchema) {
      return null;
    }

    vehicleJsonLd = {
      "@type": "ProductModel",
      "@id": vehicleSchema.id,
      name: vehicleSchema.name,
    };

    if (vehicleSchema.brand) {
      vehicleJsonLd.brand = {
        "@type": "Brand",
        name: vehicleSchema.brand,
      };
    }

    if (vehicleSchema.productionDate) {
      vehicleJsonLd.productionDate = vehicleSchema.productionDate;
    }

    if (vehicleSchema.model) {
      vehicleJsonLd.model = vehicleSchema.model;
    }

    if (vehicleSchema.imageId) {
      vehicleJsonLd.image = {
        "@id": vehicleSchema.imageId,
      };
    }

    return vehicleJsonLd;
  }

  /**
   * @returns {JsonLdObject}
   */
  function getOrganizationJsonLd() {
    var organization = getOrganizationSchemaContext();
    var organizationJsonLd = {
      "@type": "Organization",
      "@id": organization.id,
      name: organization.name,
    };

    if (organization.url) {
      organizationJsonLd.url = organization.url;
    }

    if (organization.logoUrl) {
      organizationJsonLd.logo = {
        "@type": "ImageObject",
        "@id": organization.id + "-logo",
        url: organization.logoUrl,
        contentUrl: organization.logoUrl,
      };
    }

    if (organization.telephone) {
      organizationJsonLd.telephone = organization.telephone;
    }

    if (organization.email) {
      organizationJsonLd.email = organization.email;
    }

    if (organization.sameAs.length) {
      organizationJsonLd.sameAs = organization.sameAs;
    }

    return organizationJsonLd;
  }

  return {
    companyName: COMPANY_NAME,
    companyUrl: COMPANY_URL,
    companyLogoUrl: COMPANY_LOGO_URL,
    imageLicenseUrl: IMAGE_LICENSE_URL,
    imageAcquireLicenseUrl: IMAGE_ACQUIRE_LICENSE_URL,
    inStockUrl: IN_STOCK_URL,
    newConditionUrl: NEW_CONDITION_URL,
    priceCurrency: PRICE_CURRENCY,
    getAbsoluteUrl: getAbsoluteUrl,
    stripHtml: stripHtml,
    toNumber: toNumber,
    getComponentTitle: getComponentTitle,
    getComponentCategory: getComponentCategory,
    isWheelOrTire: isWheelOrTire,
    isWheelOrTireComponent: isWheelOrTireComponent,
    getProductUrl: getProductUrl,
    getProductDomId: getProductDomId,
    getAdditionalProperties: getAdditionalProperties,
    getProductSchemaContext: getProductSchemaContext,
    getProductJsonLd: getProductJsonLd,
    getPublicationYear: getPublicationYear,
    getImageSchemaContext: getImageSchemaContext,
    getImageJsonLd: getImageJsonLd,
    getVehicleName: getVehicleName,
    getVehicleSchemaContext: getVehicleSchemaContext,
    getVehicleJsonLd: getVehicleJsonLd,
    getOrganizationSchemaContext: getOrganizationSchemaContext,
    getOrganizationJsonLd: getOrganizationJsonLd,
  };
});
